import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import './plugins/axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import Geocoder from "@pderas/vue2-geocoder"
import { store } from './store/store'
const GMAP_KEY = process.env.VUE_APP_GMAP_API_TOKEN

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: GMAP_KEY,
    libraries: 'places',
  }
})
Vue.use(Geocoder, {
  defaultCountryCode: null, // e.g. 'CA'
  defaultLanguage:    'th', // e.g. 'en'
  defaultMode:        'lat-lng', // or 'lat-lng'
  googleMapsApiKey:   GMAP_KEY
});

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
